import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=00018825"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordModal.vue?vue&type=style&index=0&id=00018825&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports